module.exports = __webpack_public_path__ + "assets/img/title-e5c58339.png";